import APIError from './APIError';

export default class ResourceError extends APIError {
  static HTTP_CODES = [409];

  static ERROR_CODES = {
    CONFLICT: 'conflict',
  };

  constructor(error) {
    super({ name: 'ResourceError', message: 'This request threw a resource error' });

    this.response = undefined;
    this.status = undefined;
    this.code = undefined;
    this.reason = undefined;
    this.data = undefined;
    this.parsePayload(error);
  }

  parsePayload(error) {
    const errorResponse = error?.response;
    const errorData = errorResponse?.data;

    this.response = errorResponse;
    this.status = errorResponse?.status;
    this.code = ResourceError.ERROR_CODES[errorData?.code] || errorData?.code;
    this.reason = errorData?.reason;
    this.data = errorData?.data;
  }

  static matchesFormat(error) {
    const errorStatus = error?.response?.status;
    const errorCode = error?.response?.data?.code;
    if (!errorStatus) return false;

    const hasAccessStatus = ResourceError.HTTP_CODES.includes(errorStatus);
    const hasAccessCode = errorCode in ResourceError.ERROR_CODES;
    return hasAccessStatus && hasAccessCode;
  }
}
